const t = {
  name: "Cross",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 10.5859L5.00015 3.58594L3.58594 5.00015L10.5859 12.0002L3.58594 19.0002L5.00015 20.4144L12.0002 13.4144L19.0002 20.4144L20.4144 19.0002L13.4144 12.0002L20.4144 5.00015L19.0002 3.58594L12.0002 10.5859Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Cross
};
